export default __webpack_public_path__ + "static/media/6F5.3cf136db.svg";